var codeblock_default = {
  "blockStyleSpacing": "_2LDAW",
  "codeBlock": "QbJkL _2LDAW",
  "renderedInTable": "FIym3"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
